import { Component, OnInit } from '@angular/core';
//import { default as data_json } from './sample.json';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-demo-claims-inbox',
  templateUrl: 'demo-claims-inbox.component.html',
  styleUrls: ['demo-claims-inbox.component.scss']
})
export class DemoClaimsInboxComponent implements OnInit {

  constructor(
      private message: NzMessageService,
      private route: ActivatedRoute,
  ){}

  productType: string = "claims-life";

  ngOnInit() {
    this.randomizeList();
    this.loadCases('myCases');
    //console.log(data_json);
    this.productType = this.route.snapshot.paramMap.get('product') || this.productType;
    this.handleStateChange(this.productType);
  }


  optionTEMP = 0;
  isLoading = false;

  radioValue = 'myCases';

  randomizeList = function() {
    this.loadFaker();
    this.list = this.list.sort(() => Math.random() - 0.5);
  };

  loadFaker = function() {
    this.isLoading = true;
    setTimeout(() => { this.isLoading = false }, 1250);
  };

  list:any = [ // Not used (used only for *ngFor)
    { "id": 1, "proposalNum": "P0010114", "isCollapsed": true },
    { "id": 2, "proposalNum": "P0020313", "isCollapsed": true },
    { "id": 3, "proposalNum": "P0010297", "isCollapsed": true },
  ];



  loadCases(section:string='myCases'){
    if('teamCases'==section) { this.nodes = this.nodes_teamCases }
    else if ('subCases'==section){ this.nodes = this.nodes_subCases }
    else { this.nodes = this.nodes_myCases }
    this.treeClick({id:0});
  }

  /* Data for Nodes */
  nodes = [];
  nodes_subCases = [
    {
      title   : 'My Suboridinates',
      key     : '1010',
      expanded: true,
      icon    : 'anticon anticon-user-add',
      children: [
        { title: 'Jake Peralta ', key: '1001', icon: 'anticon anticon-user', isLeaf: true },
        { title: 'Lenny Helm', key: '1001', icon: 'anticon anticon-user', isLeaf: true },
        { title: 'Lincon Law', key: '1002', icon: 'anticon anticon-user', isLeaf: true },
        { title: 'Thomas Joseph', key: '1002', icon: 'anticon anticon-user', isLeaf: true },
        { title: 'Richard Hawkin', key: '1002', icon: 'anticon anticon-user', isLeaf: true },
      ]
    }
  ];
  nodes_teamCases = [
    {
      title   : 'REG1 Office',
      key     : '100',
      expanded: true,
      icon    : 'anticon anticon-user-add',
      children: [
        { title: 'Tom Holland', key: '1001', icon: 'anticon anticon-user', isLeaf: true },
        { title: 'Chris Evans', key: '1001', icon: 'anticon anticon-user', isLeaf: true },
        { title: 'Mark Ruffalo', key: '1002', icon: 'anticon anticon-user', isLeaf: true },
        { title: 'Paul Rudd', key: '1002', icon: 'anticon anticon-user', isLeaf: true },
        { title: 'Liz. Olsen ', key: '1002', icon: 'anticon anticon-user', isLeaf: true },
      ]
    },
    {
      title   : 'REG S.Office',
      key     : '1010',
      expanded: true,
      icon    : 'anticon anticon-user-add',
      children: [
        { title: 'Jake Peralta ', key: '1001', icon: 'anticon anticon-user', isLeaf: true },
        { title: 'Lenny Helm', key: '1001', icon: 'anticon anticon-user', isLeaf: true },
        { title: 'Lincon Law', key: '1002', icon: 'anticon anticon-user', isLeaf: true },
        { title: 'Thomas Joseph', key: '1002', icon: 'anticon anticon-user', isLeaf: true },
        { title: 'Richard Hawkin', key: '1002', icon: 'anticon anticon-user', isLeaf: true },
      ]
    }
  ];
  nodes_myCases = [
    {
      title   : 'My Cases',
      key     : '100',
      expanded: true,
      icon    : 'anticon anticon-user',
      children: [
        { title: 'All Cases ', key: '1001', icon: 'anticon anticon-profile', isLeaf: true },
        { title: 'Starred Cases', key: '1001', icon: 'anticon anticon-star', isLeaf: true },
      ]
    },
    {
      title   : 'Frozen Cases',
      key     : '100',
      expanded: true,
      icon    : 'anticon anticon-user',
      children: [
        { title: 'All Pending Cases', key: '1001', isLeaf: true },
        { title: 'Pending Requirement', key: '1001', isLeaf: true },
        { title: 'Pending Reference', key: '1001', isLeaf: true },
        //{ title: 'Pending Committee', key: '1002', isLeaf: true },
      ]
    },
    {
      title   : 'Filtered by:',
      key     : '101',
      expanded: true,
      icon    : 'anticon anticon-user',
      children: [
        { title: 'High Value Cases', key: '1001', isLeaf: true },
      ]
    },
  ];
  treeClick(data:any){
    console.log("treeClick Data:", data);
    this.loadFaker();
  }



  /* TEMP DEMO CODE */
  /* Set State & Claim Type */
  /* Handle State Changes -- Shows a fake loader for 1.2 seconds, and changes variables */
  productTypeNiceName = "Claim";
  handleStateChange(newState) {
    let time = 640;
    this.loadFaker();
    this.message.loading('Updating view ...', { nzDuration: time });
    //setTimeout(()=>{ this.message.success('Loaded new view', { nzDuration: time }) }, time);
    if('underwriting-health'==newState) this.productTypeNiceName = "Underwriting";
    else this.productTypeNiceName = "Claim";
  }


}
